import React, { useEffect, useState } from 'react'
import BasicPieChart from '../BasicPieChart/BasicPieChart'

const InsightLackOfInfo = (props) => {
  const [percentage, setPercentage] = useState(0)
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    const getChartInfo = () => {
      let percentage = 0
      if (props.insightInfo.campaignStatus === 'lack') {
        percentage = percentage + props.insightInfo.campaignPercent * 100
      } else {
        percentage = percentage + 33
      }
      if (props.insightInfo.clickStatus === 'lack') {
        percentage = percentage + props.insightInfo.clickPercent * 100
      } else {
        percentage = percentage + 33
      }
      if (props.insightInfo.conversionStatus === 'lack') {
        percentage = percentage + props.insightInfo.conversionPercent * 100
      } else {
        percentage = percentage + 33
      }
      setPercentage(percentage)
      setLoading(false)
    }
    getChartInfo()
    return () => {}
  }, [props])
  return (
    <>
      {loading ? (
        <></>
      ) : (
        <div className="flex justify-center items-center h-[calc(100vh-275px)]">
          <div className="grid gap-5 w-2/5">
            <div className="flex justify-center items-center">
              <BasicPieChart percentage={percentage}></BasicPieChart>
            </div>
            {(props.insightInfo.campaignStatus === 'lack' ||
              props.insightInfo.clickStatus === 'lack' ||
              props.insightInfo.conversionStatus) && (
              <div className="flex justify-center items-center font-bold text-xl">
                To view insights:
              </div>
            )}
            {props.insightInfo.campaignStatus === 'lack' && (
              <div className="flex justify-center items-center">
                <label className="flex text-left rounded placeholder-black text-lg p-2.5 px-4 break-normal w-full lg:w-2/3">
                  <div className="mx-6">
                    At least {props.infoLimits[1]} campaigns required.
                  </div>
                </label>
              </div>
            )}
            {props.insightInfo.clickStatus === 'lack' && (
              <div className="flex justify-center items-center">
                <label className="flex bg-metrinome-green text-left rounded placeholder-black text-lg p-2.5 px-4 break-normal w-full lg:w-2/3">
                  <div className="mx-6">
                    At least {props.infoLimits[1]} clicks required.
                  </div>
                </label>
              </div>
            )}
            {props.insightInfo.conversionStatus === 'lack' && (
              <div className="flex justify-center items-center">
                <label className="flex bg-metrinome-green text-left rounded placeholder-black text-lg p-2.5 px-4 break-normal w-full lg:w-2/3">
                  <div className="mx-6">
                    At least {props.infoLimits[1]} conversions required.
                  </div>
                </label>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default InsightLackOfInfo
